import { FormattedMessage } from 'react-intl';
import { ReactComponent as EnvelopeOpen } from '../../../assets/icons/envelope-open.svg';
import { ReactComponent as CheckedBadgeOutline } from '../../../assets/icons/check-badge/outline.svg';
import { H3 } from '../../Heading/Heading';
import css from './ContactFormOption.module.css';

const CustomRadioButtonIcon = () => (
  <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <circle className={css.notChecked} cx="16" cy="16" r="9" strokeWidth="2" fill="none" />
    <g className={css.checked} fill="none" fillRule="evenodd">
      <circle strokeWidth="2" cx="16" cy="16" r="9" />
      <circle fill="#000" fillRule="nonzero" cx="16" cy="16" r="5" />
    </g>
  </svg>
);

const ContactFormOption = ({ type = 'generalInquiry', setContactType, activeType }) => {
  const variants = {
    generalInquiry: {
      id: 'contact-general-inquiry',
      value: 'generalInquiry',
      icon: <EnvelopeOpen />,
      titleId: 'ContactForm.generalInquiry',
      descriptionId: 'ContactForm.generalInquiry.description',
    },
    verification: {
      id: 'contact-verification',
      value: 'verification',
      icon: <CheckedBadgeOutline />,
      titleId: 'ContactForm.requestVerification',
      descriptionId: 'ContactForm.requestVerification.description',
    },
  };

  const variant = variants[type];

  return (
    <label htmlFor={variant.id} className={css.mainWrapper}>
      <input
        id={variant.id}
        name="contact-type-option"
        value={variant.value}
        type="radio"
        className={css.input}
        checked={activeType === variant.value}
        onChange={() => setContactType(variant.value)}
      />
      <div className={css.variantBox}>
        <div className={css.variantBoxHeader}>
          <div className={css.variantIcon}>{variant.icon}</div>
          <div className={css.radioButtonPlaceholder}>
            <CustomRadioButtonIcon />
          </div>
          <H3 className={css.variantBoxH3}>
            <FormattedMessage id={variant.titleId} />
          </H3>
        </div>
        <p className={css.variantBoxP}>
          <FormattedMessage id={variant.descriptionId} />
        </p>
      </div>
    </label>
  );
};

export default ContactFormOption;
